/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'expand-nav': {
    viewBox: '0 0 24 24',
    data: '<g id="nav-expand"><rect x="18" y="6" width="2" height="12" rx="1" ry="1"/><rect x="4" y="16" width="12" height="2" rx="1" ry="1"/><rect x="12" y="6" width="4" height="2" rx="1" ry="1"/><rect x="8" y="11" width="8" height="2" rx="1" ry="1"/></g>'
  }
})
